import { useEffect } from "react";

let lockCount = 0;
let previousBodyOverflow: string | undefined;
let previousBodyPaddingRight: string | undefined;

export const useBodyScrollLock = (isLocked: boolean) => {
  useEffect(() => {
    if (!isLocked) return;

    if (lockCount === 0) {
      // Measure before hiding overflow — once the scrollbar is gone the gap reads 0.
      const scrollbarWidth =
        window.innerWidth - document.documentElement.clientWidth;
      const currentPaddingRight =
        Number.parseFloat(getComputedStyle(document.body).paddingRight) || 0;

      previousBodyOverflow = document.body.style.overflow;
      previousBodyPaddingRight = document.body.style.paddingRight;
      document.body.style.overflow = "hidden";

      if (scrollbarWidth > 0) {
        document.body.style.paddingRight = `${currentPaddingRight + scrollbarWidth}px`;
      }
    }

    lockCount += 1;

    return () => {
      lockCount = Math.max(lockCount - 1, 0);

      if (lockCount === 0) {
        document.body.style.overflow = previousBodyOverflow ?? "";
        document.body.style.paddingRight = previousBodyPaddingRight ?? "";
        previousBodyOverflow = undefined;
        previousBodyPaddingRight = undefined;
      }
    };
  }, [isLocked]);
};
